"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) { return ({
    small: {
        fontSize: '12px'
    },
    medium: {
        fontSize: '16px'
    },
    large: {
        fontSize: '24px'
    },
    root: function (_a) {
        var color = _a.color;
        return ({
            color: theme.colors[color],
            display: 'inline-block',
            fill: 'currentcolor'
        });
    }
}); });
